import { useMutation, useQuery } from "react-query";
import * as gateway from "services/configuration/rfid/rfid";

export const useGatewayList = () => {
  return useMutation((formData) => gateway.getGatewayList(formData));
};

export const useAddGateway = () => {
  return useMutation((formData) => gateway.addGateway(formData));
};

export const useEditGateway = () => {
  return useMutation((formData) => gateway.editGateway(formData));
};

export const useDeleteGateway = () => {
  return useMutation((formData) => gateway.deleteGateway(formData));
};
export const useStatusRfid = () => {
    return useMutation((formData) => gateway.statusRfid(formData));
  };
export const useGatewayDropdownForFloor = (id) => {
  return useQuery(["gatewayDropdownForFloor", id], () => gateway.gatewayDropdownForFloor(id),
    {
      retry: false,
      enabled: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};

export const useGatewayImageMapping = (id) => {
  return useQuery(["gatewayImageMapping", id], () => gateway.gatewayImageMapping(id),
    {
      retry: false,
      enabled: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};

export const useGatewayFloorLinked = (id) => {
  return useQuery(["gatewayfloorlinked", id], () => gateway.gatewayFloorLinked(id),
    {
      retry: false,
      enabled: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};

export const useGatewayFloorImage = (id) => {
  return useQuery(["gatewayfloorImage", id], () => gateway.gatewayFloorImage(id),
    {
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};

export const useGatewayFloorImagePopup = (id) => {
  return useQuery(["gatewayfloorImagePopup", id], () => gateway.gatewayFloorImagePopup(id),
    {
      enabled: false,
      retry: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};